import { render, staticRenderFns } from "./PrescriptionForm.vue?vue&type=template&id=97b1e878&scoped=true"
import script from "./PrescriptionForm.vue?vue&type=script&lang=js"
export * from "./PrescriptionForm.vue?vue&type=script&lang=js"
import style0 from "./PrescriptionForm.vue?vue&type=style&index=0&id=97b1e878&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b1e878",
  null
  
)

export default component.exports